<template>
  <div class="footer-button">
    <vs-button class="pl-12 pr-12 btn-hanei" @click="clickSave" color="primary" type="filled">保存</vs-button>
    <vs-button class="btn-positive" color="positive" text-color="#7367F0" @click="clickCancel" type="filled">キャンセル</vs-button>
  </div>
</template>

<script>
import { 
  GET_CHECK_COUNT
} from '@/store/modules/keiyaku/actions.js'
export default {
  name: 'footer-button',
  components: {},
  props: [],
  data() {
    return {

    }
  },
  mounted() {
    this.getCheckCount()
  },
  methods: {
    clickCancel() {
      this.$emit('cancel')
    },
    clickSave() {
      this.$emit('save')
    },
    getCheckCount() {
      this.$store.dispatch(GET_CHECK_COUNT)
    }
  }
}
</script>

<style scoped>
.footer-button {
  display: flex;
  justify-content: flex-end;
  margin: 30px;
  gap: 30px;
  position: fixed;
  z-index: 10001;
  background: #f8f8f8;
  padding: 9px 30px 7.5px;
  border-radius: 4px;
  right: 3px;
  width: calc((100% - 80px) - 6px);
  margin: 0px;
  bottom: 3px;
  border: 1px solid #dddddd;
  box-shadow: 0px 4px 25px 0px rgb(0 0 0 / 15%);
}

.content-area-reduced .footer-button {
  width: calc((100% - 260px) - 6px);
}
.btn-positive {
  border: 1px solid #7367F0;
}
</style>
